import { createAsyncThunk } from '@reduxjs/toolkit';
import firebase from 'firebase/app';
import { postStatuses } from '../../components/projectPost/Post';
import { postsPages } from '../../components/projectSubCategory/SubCategory';
import { INVITE_ALL_USERS } from '../../constants/post';
import { getReviewsByPostUId } from '../../firebase/api/review';
import { invitedSubCategories } from '../../pages/InvitedPosts/InvitedPosts';
import { pendingSubCategories } from '../../pages/PendingPosts/PendingPosts';
import { publishedSubCategories } from '../../pages/PublishedPosts/PublishedPosts';
import { inProgressCategoryStatus } from '../publishedPosts/PublishedPostsThunks';

const COLLECTION_NAME = 'posts';

const getPostCollection = () => firebase.firestore().collection(COLLECTION_NAME);

export const fetchPost = createAsyncThunk(
    'fetchPost',
    async ({ id, userId, email, isAdmin }, { rejectWithValue }) => {
        try {
            if (!email) return null;

            let result = await getPostCollection()
                .doc(id)
                .get()
                .then(doc => {
                    if (doc.exists) {
                        return doc.data();
                    } else {
                        console.log('No such document!');
                        return undefined;
                    }
                })
                .catch(function (error) {
                    console.log('Error getting document:', error);
                });

            if (result && result.isDeleted === true) {
                result = undefined;
            }

            let reviews = [];

            let page, subCategoryTitle, subCategories;

            if (result !== undefined) {
                reviews = await getReviewsByPostUId(0, result.uid, 0).then(results => {
                    //first parameter is pagesize
                    if (results) {
                        return results.docs
                            .map(doc => doc.data())
                            .sort((a, b) => (b?.response?.length > a?.response?.length ? -1 : 1))
                            .sort(a =>
                                result.assignTo?.some(
                                    assignedFreelancer => assignedFreelancer.uid === a.publisherUid
                                )
                                    ? -1
                                    : 1
                            );
                        // .sort((a, b) => (result.assignTo === a.publisherUid ? -1 : 1));
                    } else return [];
                });

                if (!result.isReviewedByAdmin) {
                    page = postsPages.pending;
                    subCategories = pendingSubCategories;
                    subCategoryTitle = pendingSubCategories.pending;
                } else if (result && result.publisherUid === userId) {
                    page = postsPages.published;
                    subCategories = publishedSubCategories;
                    subCategoryTitle = inProgressCategoryStatus.includes(result.status)
                        ? publishedSubCategories.publishedInProgress
                        : publishedSubCategories.publishedNotInProgress;
                } else {
                    page = postsPages.invited;
                    subCategories = invitedSubCategories;
                    if (
                        result?.assignTo?.some(
                            assignedFreelancer => assignedFreelancer.uid === userId
                        )
                    ) {
                        // if (result?.assignTo === userId) {
                        subCategoryTitle = invitedSubCategories.inProgress;
                    } else if (
                        result.inviteColleagues.filter(inviteItem => inviteItem.email === email)
                            .length
                    ) {
                        subCategoryTitle = invitedSubCategories.invitedOpportunities;
                    } else if (result.inviteColleagues.includes(INVITE_ALL_USERS)) {
                        subCategoryTitle = invitedSubCategories.publicOpportunities;
                    }
                }
            }

            return {
                data: result,
                reviewsData: reviews,
                page: page,
                subCategories: subCategories,
                subCategoryTitle: subCategoryTitle,
                isAccessDenied:
                    result === undefined ||
                    (result !== undefined &&
                        !result.isPublicPost &&
                        result.publisherUid !== userId &&
                        (!result.inviteColleagues.filter(user => user.email === email).length || // if post is private and not invited freelancer try to view post
                            (!result.responseEmails.filter(response => response.email === email)
                                .length &&
                                result.status !== postStatuses.new &&
                                !result.assignTo?.some(
                                    assignedFreelancer => assignedFreelancer.uid === userId
                                )))), // if post is private, invited freelancer not answered and project owner already hired someone else
            };
        } catch (e) {
            return rejectWithValue(e.message);
        }
    }
);
